import React, { useMemo } from 'react';
import { SessionStepProps } from '../SessionFlowBase';
import styled from 'styled-components';
import SessionVideoEnterUrl from './SessionVideoEnterUrl';
import useSession from '../../Util/useSession';

interface Props extends SessionStepProps {}

const SessionVideosEnterUrl: React.FunctionComponent<Props> = ({ sessionid }) => {
  const { session } = useSession(sessionid);

  const nextSortOrder = useMemo(() => {
    const sorted = session?.videos?.slice()?.sort((a, b) => (b.sortOrder || 0) - (a.sortOrder || 0)) || [];
    if (sorted.length > 0) {
      return (sorted[0].sortOrder || 0) + 1;
    }
    return 0;
  }, [session]);

  let baseFps;
  if (session?.videos && session.videos.length > 0 && session.videos[0].fps) {
    baseFps = session.videos[0].fps;
  }

  return (
    <Container>
      <Wrapper>
        {session?.videos
          ?.filter((video) => video.url?.indexOf('session.smart') === -1)
          ?.map((video, index) => (
            <SessionVideoEnterUrl sessionid={sessionid} key={index} video={video} label={'Video ' + (index + 1)} />
          ))}
        <SessionVideoEnterUrl
          sessionid={sessionid}
          key="new"
          label={'New video'}
          sortOrder={nextSortOrder}
          baseFps={baseFps}
        />
      </Wrapper>
    </Container>
  );
};

const Container = styled.div``;

const Wrapper = styled.div`
  max-width: 700px;
`;

export default SessionVideosEnterUrl;
